import packageLogo from "@assets/images/package.png";
import { Button, Divider } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";

import constants from "../constants";

const useStyles = makeStyles(
  theme => ({
    button: {
      marginRight: theme.spacing(1)
    },
    buttonsSpan: {
      color: "#002972",
      display: "flex",
      justifyContent: "center"
    },
    cancelButton: {
      backgroundColor: "#ffffff",
      border: "1px solid #E5E5E5",
      marginRight: theme.spacing(2)
    },
    deleteButton: {
      "& span": {
        color: "#002972"
      },
      "&:disabled span": {
        color: "#BAC8FF"
      },
      "&:hover": {
        backgroundColor: theme.palette.error.dark
      },
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    editButton: {
      "&:active": {
        "& span": {
          color: "#002972"
        },
        backgroundColor: "#FFCE22",
        boxShadow: "inset 0px 0px 0px 2px #D0A73E"
      },
      "&:hover": {
        backgroundColor: "#FFD15C",
        boxShadow: "inset 0px 0px 0px 1px #D0A73E"
      },
      backgroundColor: "#FFD15C"
    },
    fieldsSpan: {
      display: "flex",
      flexDirection: "column"
    },
    labelStyles: {
      fontSize: "17px",
      fontWeight: 400
    },
    packageLogo: {
      "& img": {
        height: "18px",
        marginRight: "15px",
        marginTop: "-10px",
        width: "18px"
      },
      alignItems: "center",
      display: "flex"
    }
  }),
  { name: "HomeLocationActions" }
);
{
  /* #TODO: refactor interface based on updated endpoint*/
}
interface HomeLocationProps {
  onDelete?: () => void;
  onEdit?: (data: any) => void;
  name: string;
  latitude: number;
  longitude: number;
  remarks: string;
  id: any;
}

function HomeLocation(props: HomeLocationProps) {
  const classes = useStyles(props);
  const { HOME_LOCATION_SPIELS } = constants;
  const { latitude, longitude, name, onDelete, onEdit, remarks } = props;

  return (
    <>
      <CardContent>
        <span className={classes.packageLogo}>
          <img src={packageLogo} alt="package-logo" />
          <Typography variant="h6" gutterBottom>
            {name}
          </Typography>
        </span>
        <Grid container spacing={3}>
          <Grid item xs={12} sm>
            <span className={classes.fieldsSpan}>
              <Typography variant="h6" gutterBottom>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.LATITUDE}
              </Typography>
              <label className={classes.labelStyles}>{latitude}</label>
            </span>
          </Grid>
          <Grid item xs={12} sm>
            <span className={classes.fieldsSpan}>
              <Typography variant="h6" gutterBottom>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.LONGITUDE}
              </Typography>
              <label className={classes.labelStyles}>{longitude}</label>
            </span>
          </Grid>
          <Grid item xs={12}>
            <span className={classes.fieldsSpan}>
              <Typography variant="h6" gutterBottom>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.REMARKS}
              </Typography>
              <label className={classes.labelStyles}>{remarks}</label>
            </span>
          </Grid>
          <Grid item xs={12}>
            <span className={classes.buttonsSpan}>
              <Button className={classes.cancelButton} onClick={onDelete}>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_ACTION.DELETE}
              </Button>
              <Button className={classes.editButton} onClick={onEdit}>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_ACTION.EDIT}
              </Button>
            </span>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </>
  );
}

export default HomeLocation;
